import { useRef } from 'react'
import { Rock } from '../../types'
import FloatingMenu from '../shared/FloatingMenu'
import RockCheckInForm from './RockCheckInForm'
import { useFocusTrap } from '../shared/useFocusTrap'

interface Props {
  rock: Rock
  teamId: number
  meetingId?: number
  onClose: () => void
  anchorRef: React.RefObject<HTMLElement>
  notePlaceholder?: string
}

export default function RockCheckInPopover({ rock, teamId, meetingId, onClose, anchorRef, notePlaceholder }: Props) {
  const containerRef = useRef<HTMLDivElement>(null)
  useFocusTrap(containerRef, true)

  return (
    <FloatingMenu
      open
      onClose={onClose}
      anchorRef={anchorRef}
      width={288}
      className="bg-white rounded-xl shadow-xl border border-stone/20 p-4 w-72"
    >
      <div ref={containerRef}>
        <h4 className="text-sm font-semibold text-text-primary mb-3">Quick Check-In</h4>
        <p className="text-sm text-text-secondary mb-3 truncate">{rock.title}</p>

        <RockCheckInForm
          rock={rock}
          teamId={teamId}
          meetingId={meetingId}
          onClose={onClose}
          notePlaceholder={notePlaceholder}
          compact
        />
      </div>
    </FloatingMenu>
  )
}
